/* global history */
// Router for Leads
//
// List leads here
// #basic
//
module.exports = (function() {
    var $       = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
    var Events = require('common/events');
    var bumpSelectors = [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        '.bump-link'
    ];
    var $bumps;
    var headerOffset = 140;

    var bumped = function() {
        $('body').trigger('links-bumped');
    };

    var bump = function($bump) {
        $bump.trigger('link-bumped');

        var bumpOffset = $bump.offset().top;
        var scrollTop = bumpOffset - headerOffset;

        $('html,body').scrollTop(scrollTop);

        bumped();
    };

    // Fires when the hash is updated, should react accordingly
    var checkBumps = function(event) {

        if ( event && event.preventDefault ) {
            event.preventDefault();
        }

        var bumpID = location.hash;
        var modals;
        var bumped = false;

        if (bumpID.length > 0) {
            var $bump = $bumps.filter(bumpID);

            // Matches a bump link
            if ($bump.length > 0) {
                bumped = true;
                bump($bump);

                $(window).one('scroll', bump.bind(this, $bump));
            }
        }

        return bumped;
    };

    var init = function() {
        $bumps = $(bumpSelectors.join(','));

        $(window).on('load', checkBumps);
        $(window).on('hashchange', checkBumps);
    };

    return {
        init: init
    };

})();
